import { render } from "./NotificationError.vue?vue&type=template&id=2803734a&ts=true"
import script from "./NotificationError.vue?vue&type=script&lang=ts"
export * from "./NotificationError.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__